import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { CompanyLogoProvider } from './contexts/CompanyLogoContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ThemeContextProvider } from './contexts/ThemeContext';
import { DateFormatProvider } from './contexts/DateFormatContext';
import ErrorBoundary from './components/ErrorBoundary';
import { wireGlobalErrorLogging } from './services/logger';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// When the renderer is loaded via the Electron desktop shell, the page
// origin is `file:///.../index.html`. `BrowserRouter` reads
// `window.location.pathname`, which under file:// is the absolute path
// to the HTML file (e.g. `/C:/Program Files/Forge Halima/.../index.html`)
// — that matches none of our app routes, and we have no catch-all,
// so the app renders nothing. `HashRouter` keeps the route in the URL
// fragment instead, which works identically regardless of the page
// origin.
//
// This switch is purely runtime — the web deploy continues to use
// `BrowserRouter` (deep-link friendly), and `react-router-dom` exports
// both implementations from the same package so there is no extra
// bundle-size cost on the web.
const isDesktopShell =
  (typeof window !== 'undefined' &&
    (window.location.protocol === 'file:' ||
      Boolean((window as any).__RUNTIME_API_URL__))) ||
  false;

const Router = isDesktopShell ? HashRouter : BrowserRouter;
wireGlobalErrorLogging();

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router>
        <ThemeContextProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <AuthProvider>
              <CompanyLogoProvider>
                <NotificationProvider>
                  <DateFormatProvider>
                    <App />
                  </DateFormatProvider>
                </NotificationProvider>
              </CompanyLogoProvider>
            </AuthProvider>
          </LocalizationProvider>
        </ThemeContextProvider>
      </Router>
    </ErrorBoundary>
  </React.StrictMode>
);
